import { render, staticRenderFns } from "./admin-add-one-inservice-number.vue?vue&type=template&id=b748424e&scoped=true&"
import script from "./admin-add-one-inservice-number.vue?vue&type=script&lang=js&"
export * from "./admin-add-one-inservice-number.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b748424e",
  null
  
)

export default component.exports